import { type ReactNode, useMemo } from "react";
import { ConvexReactClient, ConvexProviderWithAuth } from "convex/react";
import { usePrivy } from "@privy-io/react-auth";
import configs from "../configs";

const convex = new ConvexReactClient(
  configs.CONVEX_URL || "https://placeholder-url.convex.cloud",
);

export function ConvexClientProvider({ children }: { children: ReactNode }) {
  const { getAccessToken, authenticated, ready } = usePrivy();

  const useAuthFromPrivy = useMemo(
    () => ({
      isLoading: !ready,
      isAuthenticated: authenticated,
      fetchAccessToken: async () => {
        const token = await getAccessToken();
        // Debug: log token (first 20 chars only for security)
        if (token) {
          console.log(
            "[Convex] Token fetched:",
            token.substring(0, 20) + "...",
          );
        } else {
          console.warn("[Convex] No token available from Privy");
        }
        return token || null;
      },
    }),
    [ready, authenticated, getAccessToken],
  );

  return (
    <ConvexProviderWithAuth client={convex} useAuth={() => useAuthFromPrivy}>
      {children}
    </ConvexProviderWithAuth>
  );
}
